<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d7e199212"><big>A<i>cknowledgments </i></big></p>
<p class="tx1" id="d7e200112">I am grateful to Fr. Paul John, a Catholic priest who was born in India and knows so much about the culture and ideas, present and past. My conversations with him have been invaluable. I am very fortunate to have known him for these last six years. I have also benefited from exchanging ideas with my coauthor (and an author in his own right), Susai Anthony, who sees Hinduism clearly for what it is, not romantically for what some would turn it into.</p>
<p class="tx1" id="d7e203412">Finally, I appreciate the patience and equanimity of my editor Lisa Laing, who gave me the time I needed to learn what I know about this ancient way of life.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Anth_9781605507507_epub_c8_r1.vue?45f39177